import React, { Suspense } from 'react'
import { CreditScore, DownPayment, LoanAmount, PropertyValue, ZipCode, MortgageType, Price, CashOut } from './inputs'
import LoanOptionsLeftRail from './inputs/LoanOptionsLeftRail'
import { useStoreState } from 'store'
import MoreFiltersToggle from './MoreFiltersToggle'

export default function LeftRailFilters() {
  const { mortgageType } = useStoreState(state => state.dimensions.dimensions)

  return (
    <>
      <div className="mb-6">
        <MortgageType className="pr-2" />
      </div>
      <div className="mb-6">
        <ZipCode />
      </div>
      {mortgageType === 'Purchase' && (
        <div className="mb-6 display-flex align-items-flex-end flex-direction-column">
          <Price />
          <DownPayment />
        </div>
      )}
      {mortgageType === 'Refinance' && (
        <>
          <div className="mb-6">
            <PropertyValue />
          </div>
          <div>
            <CashOut className="mb-6" />
          </div>
          <div>
            <LoanAmount className="mb-6" />
          </div>
        </>
      )}
      <div>
        <CreditScore className="mb-6" />
      </div>
      <div className="mb-6 loan-options">
        <label className="FormLabel" htmlFor="mortgageTerms">
          Loan term
        </label>
        <LoanOptionsLeftRail />
      </div>
      <div className="">
        <Suspense fallback={<div />}>
          <MoreFiltersToggle />
        </Suspense>
      </div>
    </>
  )
}
